import styled from 'styled-components';
import slide5 from 'assets/images/desktop/slide5.jpg';
export { Subtitle } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  background: url(${slide5}) no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  @media screen and (min-width: 2140px) {
    background-position-y: top;
  }
`;
